import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { isStandalone, isIos, isDismissed, dismiss } from '../../utils/pwaInstall';
import './InstallPrompt.css';

/**
 * Aviso discreto para instalar a app no telemóvel.
 *
 *  - Android/Chrome: aparece quando o browser oferece a instalação (beforeinstallprompt) e o botão
 *    dispara esse mesmo prompt.
 *  - iPhone/Safari: NÃO há beforeinstallprompt — em vez de um botão que não faz nada, mostra-se a
 *    instrução real (Partilhar → Adicionar ao ecrã principal).
 *  - Já instalada (display-mode: standalone) ou dispensada há pouco: não aparece.
 *  - Nunca a meio de um treino.
 */
export default function InstallPrompt() {
  const location = useLocation();
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);
  const [ios, setIos] = useState(false);

  useEffect(() => {
    if (isStandalone()) return undefined;
    if (isDismissed(window.localStorage)) return undefined;

    const onPrompt = (event) => {
      event.preventDefault();
      setDeferred(event);
      setVisible(true);
    };
    window.addEventListener('beforeinstallprompt', onPrompt);

    if (isIos(window)) {
      setIos(true);
      setVisible(true);
    }

    return () => window.removeEventListener('beforeinstallprompt', onPrompt);
  }, []);

  if (!visible || /^\/(treino|workout)(\/|$)/.test(location.pathname)) return null;

  const close = () => {
    dismiss(window.localStorage);
    setVisible(false);
  };

  const install = async () => {
    if (!deferred) return;
    try {
      await deferred.prompt();
    } catch (e) {
      // o browser recusou o prompt (já consumido): cai no fecho normal
    }
    setDeferred(null);
    setVisible(false);
  };

  return (
    <div className="install-prompt" role="dialog" aria-label="Instalar a aplicação">
      {ios ? (
        <>
          <p className="install-prompt__text">
            <strong>Instala o GyMag no teu telemóvel:</strong> toca em <strong>Partilhar</strong> e depois
            em <strong>Adicionar ao ecrã principal</strong>.
          </p>
          <div className="install-prompt__actions">
            <button type="button" className="install-prompt__btn install-prompt__btn--primary" onClick={close}>
              Entendi
            </button>
          </div>
        </>
      ) : (
        <>
          <p className="install-prompt__text">
            <strong>Instala o GyMag</strong> no teu telemóvel para abrires mais depressa.
          </p>
          <div className="install-prompt__actions">
            <button type="button" className="install-prompt__btn install-prompt__btn--primary" onClick={install}>
              Instalar
            </button>
            <button type="button" className="install-prompt__btn" onClick={close}>
              Agora não
            </button>
          </div>
        </>
      )}
    </div>
  );
}
